<template>
    <div class="coursePersonnel-list">
        <div class="manage-wrapper">
            <div class="table-wrapper">
                <h2 class="table-title">
                    <img src="../../assets/images/main/bulltin-icon.png" alt="" class="title-icon">观思问管理</h2>
                <el-form :inline="true" :model="formInline" class="demo-form-inline flex-align-between">
                    <div class="formInline-left flex-layout">
                        <!-- <el-form-item label="行为 :">
                            <el-select v-model="formInline.activityType" placeholder="选择行为" style="width: 230px;">
                                <el-option label="全部" value="">全部</el-option>
                                <el-option label="大赛类" value="0"></el-option>
                                <el-option label="教研类" value="1"></el-option>
                                <el-option label="合作学习墙" value="2"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <!-- <el-form-item label="阶段 :">
                            <el-select v-model="formInline.activityType" placeholder="选择阶段" style="width: 230px;">
                                <el-option label="全部" value="">全部</el-option>
                                <el-option label="大赛类" value="0"></el-option>
                                <el-option label="教研类" value="1"></el-option>
                                <el-option label="合作学习墙" value="2"></el-option>
                            </el-select>
                        </el-form-item> -->
                    </div>
                    <div class="formInline-right" @click="exportFile">
                        <div class="export-btn csp" style="margin-right:10px"><i class="export-icon"></i>导出
                        </div>
                    </div>
                </el-form>
                <div class="table">
                    <el-table :data="tableData" border style="width: 100%">
                        <el-table-column type="index" label="序号" style="background:#2373EC" align="center">
                        </el-table-column>
                        <el-table-column prop="actionName" label="行为" align="center" width="100">
                            <template slot-scope="scope">
                                {{ scope.row.actionName || '--' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="content" label="内容" align="center" min-width="200" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.content || '--' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="stageName" label="所属阶段" align="center" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.stageName || '--' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="questTime" label="内容时间" align="center" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.questTime || '--' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="提交时间" align="center" show-overflow-tooltip>
                            <template slot-scope="scope">
                                {{ scope.row.createTime || '--' }}
                            </template>
                        </el-table-column>
                    </el-table>
                    <pagination v-show="pages.total > 0" :total="pages.total" :page.sync="pages.currentPage"
                        :limit.sync="pages.pageSize" @pagination="handlePageChange">
                    </pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { saveAs } from 'file-saver'

const TITLE_TYPE_MAP = {
    0: '观',
    1: '思',
    2: '问',
    3: '听',
}
const MARK_NAME_MAP = {
    1: '集中培训',
    2: '跟岗研修',
    3: '返岗实践',
}

export default {
    data() {
        return {
            pages: {
                currentPage: 1,
                pageSize: 10,
                total: 0,
            },
            tableData: [],
            formInline: {},
            exporting: false,
            exportPollTimer: null,
            exportAborted: false,
        }
    },
    computed: {
        stageId() {
            return this.$route.query.stageId
        },
    },
    methods: {
        handlePageChange(data) {
            this.pages.currentPage = data.pageIndex
            this.pages.pageSize = data.pageSize
            this.getUserStudyInfo();
        },
        buildQuery(extra) {
            let params = {
                projectId: this.$store.state.user.currentProject.id,
                userId: this.$route.params.id,
                ...extra,
            }
            if (this.stageId) {
                params.stageId = this.stageId
            }
            return params
        },
        unwrapRecords(payload) {
            if (Array.isArray(payload)) {
                return { records: payload, total: payload.length }
            }
            if (!payload || typeof payload !== 'object') {
                return { records: [], total: 0 }
            }
            let records = payload.records || payload.list || payload.details || []
            if (!Array.isArray(records)) records = []
            let total = payload.total != null ? payload.total : records.length
            return { records, total }
        },
        pickStageName(item) {
            if (item.stageName) return item.stageName
            if (MARK_NAME_MAP[item.mark]) return MARK_NAME_MAP[item.mark]
            if (MARK_NAME_MAP[item.stageType]) return MARK_NAME_MAP[item.stageType]
            return ''
        },
        flattenRecords(records) {
            let rows = []
            records.forEach(item => {
                if (!item) return
                if (this.stageId && item.stageId != null && String(item.stageId) !== String(this.stageId)) {
                    return
                }
                let stageName = this.pickStageName(item)
                let questTime = item.questTime || ''
                let createTime = item.submitTime || item.createTime || ''
                if (item.titleType != null || (item.content != null && !item.answers && !item.questions && !item.asks)) {
                    rows.push({
                        actionName: item.actionName || item.label || TITLE_TYPE_MAP[item.titleType] || '',
                        content: item.content || item.answer || '',
                        stageName,
                        questTime,
                        createTime,
                    })
                    return
                }
                if (item.recordType === 'weekSummary' || Number(item.mark) === 4) {
                    let asks = Array.isArray(item.asks) ? item.asks : []
                    if (!asks.length) {
                        rows.push({
                            actionName: '问',
                            content: '',
                            stageName,
                            questTime,
                            createTime,
                        })
                        return
                    }
                    asks.forEach(ask => {
                        rows.push({
                            actionName: '问',
                            content: (ask && (ask.answer || ask.content)) || '',
                            stageName,
                            questTime: (ask && ask.questTime) || questTime,
                            createTime,
                        })
                    })
                    return
                }
                let q = item.questions || {}
                let a = item.answers || {}
                ;[
                    { actionName: q.observeLabel || '观', content: a.observe || '' },
                    { actionName: q.reflectLabel || q.thinkLabel || '思', content: a.think || '' },
                    { actionName: q.questionLabel || q.askLabel || '问', content: a.ask || '' },
                ].forEach(block => {
                    rows.push({
                        actionName: block.actionName,
                        content: block.content,
                        stageName,
                        questTime,
                        createTime,
                    })
                })
            })
            return rows
        },
        async getUserStudyInfo() {
            let resData = await this.$Api.StageV2.getGswSubmissionDetail(this.buildQuery({
                page: this.pages.currentPage,
                limit: this.pages.pageSize,
            }))
            if (!resData || resData.code != 200) {
                this.$message.error((resData && resData.msg) || '获取详情失败')
                this.tableData = []
                this.pages.total = 0
                return
            }
            let result = this.unwrapRecords(resData.data)
            this.tableData = this.flattenRecords(result.records)
            this.pages.total = result.total
        },
        waitExportPoll(ms) {
            return new Promise(resolve => {
                this.exportPollTimer = setTimeout(resolve, ms)
            })
        },
        async pollGswExport(taskId) {
            let start = Date.now()
            let timeout = 15 * 60 * 1000
            while (!this.exportAborted && Date.now() - start < timeout) {
                let resData = await this.$Api.StageV2.getGswExportStatus({ taskId })
                if (!resData || resData.code != 200) {
                    throw new Error((resData && resData.msg) || '导出失败')
                }
                let data = resData.data || {}
                if (data.status === 'SUCCESS') {
                    if (!data.fileName) {
                        throw new Error('导出失败')
                    }
                    return data.fileName
                }
                if (data.status === 'FAIL') {
                    throw new Error(data.errorMsg || '导出失败')
                }
                await this.waitExportPoll(2000)
            }
            if (this.exportAborted) {
                throw new Error('已取消导出')
            }
            throw new Error('导出超时，请稍后重试')
        },
        async exportFile() {
            if (this.exporting) {
                this.$message.warning('正在导出中，请稍候')
                return
            }
            if (!this.stageId) {
                this.$message.warning('请选择阶段')
                return
            }
            let userId = this.$route.params.id
            if (!userId) {
                this.$message.error('userId 不能为空')
                return
            }
            this.exporting = true
            this.exportAborted = false
            let loadingInstance = this.$loading({
                target: this.$el,
                lock: true,
                text: '正在导出中，请勿关闭页面...',
                spinner: 'el-icon-loading',
            })
            try {
                let resData = await this.$Api.StageV2.exportGswSubmissionRecordAsync({
                    projectId: this.$store.state.user.currentProject.id,
                    stageId: this.stageId,
                    userId,
                })
                if (!resData || resData.code != 200) {
                    this.$message.error((resData && resData.msg) || '导出失败')
                    return
                }
                let taskId = typeof resData.data === 'string'
                    ? resData.data
                    : (resData.data && resData.data.taskId)
                if (!taskId) {
                    this.$message.error('导出失败')
                    return
                }
                let fileName = await this.pollGswExport(taskId)
                let res = await this.$Api.StageV2.downloadGswExport({ fileName })
                let blob = res.data
                if (blob && blob.type && blob.type.indexOf('application/json') >= 0) {
                    let text = await blob.text()
                    let json = JSON.parse(text)
                    throw new Error((json && json.msg) || '导出失败')
                }
                saveAs(blob, fileName || '观思问个人明细.xlsx')
            } catch (e) {
                if (!this.exportAborted) {
                    this.$message.error((e && e.message) || '导出失败')
                }
            } finally {
                loadingInstance.close()
                this.exporting = false
                if (this.exportPollTimer) {
                    clearTimeout(this.exportPollTimer)
                    this.exportPollTimer = null
                }
            }
        },
    },
    mounted() {
        this.getUserStudyInfo();
    },
    beforeDestroy() {
        this.exportAborted = true
        if (this.exportPollTimer) {
            clearTimeout(this.exportPollTimer)
            this.exportPollTimer = null
        }
    }
}
</script>

<style lang="less" scoped>
    @import "../manage/less/table.less";

    .el-form--inline .formInline-right {
        justify-content: flex-end;
    }

    .coursePersonnel-list {

        .demo-form-inline {
            margin-bottom: 20px;
        }

        .table-wrapper {
            border-radius: 8px;
            padding-top: 10px;
            background: #fff;
            padding: 0 26px 24px;
            box-shadow: 0px 2px 10px 0px #F5F8FA;
        }

        .table-title {
            line-height: 68px;
            font-size: 17px;
        }

        // .export-btn {
        //     color: #595959;
        //     display: flex;
        //     justify-content: flex-end;
        //     margin-bottom: 10px;
        // }

        .export-icon {
            display: inline-block;
            background-image: url("~@/assets/images/admin/export.png");
            background-size: 100% 100%;
            width: 17px;
            height: 16px;
            margin-right: 8px;
            vertical-align: -2px;
        }

        .title-icon {
            width: 21px;
            height: 21px;
            margin-right: 9px;
            vertical-align: -4px;
        }

        .table {
            /deep/.el-table th {
                &>.cell {
                    white-space: pre-line;
                }
            }
        }

        @media screen and (min-width:1250px) {
            .table-wrapper {
                padding: 0 43px 24px;
            }
        }
    }
</style>
